import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n)

const availableLocales = process.env.VUE_APP_AVAILABLE_LOCALES.split(',')

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_DEFAULT_LOCALE,
  messages: {}
})

async function mountI18n() {
  const imports = availableLocales.map((locale) => import(`@/locales/${ locale }.json`))
  const messagesList = await Promise.all(imports)

  messagesList.forEach((messages, index) => {
    const locale = availableLocales[index]

    i18n.setLocaleMessage(locale, messages)
  })

  return i18n
}

export default mountI18n
